export default function carrosel() {
    document.addEventListener('DOMContentLoaded', function() {
        const carousel = document.getElementById('carousel');
        const track = document.querySelector('.carousel-track');
        const nextBtn = document.querySelector('a[href="#next"]');
        const backBtn = document.querySelector('a[href="#back"]');

        // Verifica se os elementos existem
        if (!carousel || !track || !nextBtn || !backBtn) return;

        // Configuração do scroll
        const scrollAmount = 340; // Quantidade de pixels para scrollar

        // Evento para o botão next
        nextBtn.addEventListener('click', function(e) {
            e.preventDefault();
            track.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        });

        // Evento para o botão back
        backBtn.addEventListener('click', function(e) {
            e.preventDefault();
            track.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
        });

        // Opcional: Desabilitar botões quando chegar no início/fim
        function updateButtonStates() {
            const maxScroll = track.scrollWidth - track.clientWidth;

            if (track.scrollLeft <= 0) {
                backBtn.style.opacity = '0.5';
                backBtn.style.pointerEvents = 'none';
            } else {
                backBtn.style.opacity = '1';
                backBtn.style.pointerEvents = 'auto';
            }

            if (track.scrollLeft >= maxScroll) {
                nextBtn.style.opacity = '0.5';
                nextBtn.style.pointerEvents = 'none';
            } else {
                nextBtn.style.opacity = '1';
                nextBtn.style.pointerEvents = 'auto';
            }
        }

        // Atualizar estados dos botões inicialmente e durante o scroll
        updateButtonStates();
        track.addEventListener('scroll', updateButtonStates);
    });
}
